import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "upload-home"
};
const _hoisted_2 = {
  class: "toolbar"
};
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = {
  href: "https://github.com/MarSeventh/CloudFlare-ImgBed"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "main-title",
  href: "https://github.com/MarSeventh/CloudFlare-ImgBed",
  target: "_blank"
};
const _hoisted_8 = {
  class: "dialog-action"
};
const _hoisted_9 = {
  key: 2,
  style: {
    "font-size": "medium",
    "font-weight": "bold"
  }
};
const _hoisted_10 = {
  class: "dialog-action"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_UploadForm = _resolveComponent("UploadForm");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_slider = _resolveComponent("el-slider");
  const _component_Footer = _resolveComponent("Footer");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_cache[35] || (_cache[35] = _createElementVNode("img", {
    id: "bg1",
    class: "background-image1",
    alt: "Background Image"
  }, null, -1)), _cache[36] || (_cache[36] = _createElementVNode("img", {
    id: "bg2",
    class: "background-image2",
    alt: "Background Image"
  }, null, -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_tooltip, {
    disabled: $options.disableTooltip,
    content: "上传设置",
    placement: "left"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      class: "toolbar-button",
      size: "large",
      onClick: $options.openCompressDialog,
      circle: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
        icon: "cloud-upload",
        class: "compress-icon",
        size: "lg"
      })]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }, 8, ["disabled"]), _createVNode(_component_el_tooltip, {
    disabled: $options.disableTooltip,
    content: "链接格式",
    placement: "left"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      class: "toolbar-button",
      size: "large",
      onClick: $options.openUrlDialog,
      circle: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
        icon: "link",
        class: "link-icon",
        size: "lg"
      })]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }, 8, ["disabled"]), _createVNode(_component_el_tooltip, {
    disabled: $options.disableTooltip,
    content: "管理页面",
    placement: "left"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      class: "toolbar-button",
      size: "large",
      onClick: $options.handleManage,
      circle: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
        icon: "cog",
        class: "config-icon",
        size: "lg"
      })]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }, 8, ["disabled"]), _createVNode(_component_el_tooltip, {
    disabled: $options.disableTooltip,
    content: "退出登录",
    placement: "left"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      class: "toolbar-button",
      size: "large",
      onClick: $options.handleLogout,
      circle: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
        icon: "sign-out-alt",
        class: "sign-out-icon",
        size: "lg"
      })]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }, 8, ["disabled"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("a", _hoisted_4, [_createElementVNode("img", {
    class: "logo",
    alt: "Sanyue logo",
    src: $options.logoUrl
  }, null, 8, _hoisted_5)]), _createElementVNode("h1", _hoisted_6, [_createElementVNode("a", _hoisted_7, _toDisplayString($options.ownerName), 1), _cache[14] || (_cache[14] = _createTextVNode(" ImgHub"))])]), _createVNode(_component_UploadForm, {
    selectedUrlForm: $data.selectedUrlForm,
    customerCompress: $data.customerCompress,
    compressQuality: $data.compressQuality,
    compressBar: $data.compressBar,
    serverCompress: $data.serverCompress,
    uploadChannel: $data.uploadChannel,
    uploadNameType: $data.uploadNameType,
    useCustomUrl: $data.useCustomUrl,
    customUrlPrefix: $data.customUrlPrefix,
    autoRetry: $data.autoRetry,
    class: "upload"
  }, null, 8, ["selectedUrlForm", "customerCompress", "compressQuality", "compressBar", "serverCompress", "uploadChannel", "uploadNameType", "useCustomUrl", "customUrlPrefix", "autoRetry"]), _createVNode(_component_el_dialog, {
    title: "链接格式设置",
    modelValue: $data.showUrlDialog,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.showUrlDialog = $event),
    width: $options.dialogWidth,
    "show-close": false
  }, {
    default: _withCtx(() => [_cache[23] || (_cache[23] = _createElementVNode("p", {
      style: {
        "font-size": "medium",
        "font-weight": "bold"
      }
    }, "默认复制链接", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.selectedUrlForm,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.selectedUrlForm = $event),
      onChange: $options.changeUrlForm
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        value: "url"
      }, {
        default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("原始链接")])),
        _: 1
      }), _createVNode(_component_el_radio, {
        value: "md"
      }, {
        default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("MarkDown")])),
        _: 1
      }), _createVNode(_component_el_radio, {
        value: "html"
      }, {
        default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("HTML")])),
        _: 1
      }), _createVNode(_component_el_radio, {
        value: "ubb"
      }, {
        default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("BBCode")])),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue", "onChange"]), _cache[24] || (_cache[24] = _createElementVNode("p", {
      style: {
        "font-size": "medium",
        "font-weight": "bold"
      }
    }, "自定义链接格式", -1)), _createVNode(_component_el_form, {
      "label-width": "25%"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "启用自定义"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.useCustomUrl,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.useCustomUrl = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            value: "true"
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("是")])),
            _: 1
          }), _createVNode(_component_el_radio, {
            value: "false"
          }, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode("否")])),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), $data.useCustomUrl === 'true' ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 0,
        label: "自定义前缀"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.customUrlPrefix,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.customUrlPrefix = $event),
          placeholder: "请输入自定义链接前缀"
        }, null, 8, ["modelValue"])]),
        _: 1
      })) : _createCommentVNode("", true), _cache[21] || (_cache[21] = _createElementVNode("p", {
        style: {
          "text-align": "left",
          "font-size": "small"
        }
      }, [_createElementVNode("br"), _createTextVNode("*Tips: 默认链接为https://your.domain/file/xxx.jpg，如果启用自定义链接格式，只保留xxx.jpg部分，其他部分请自行输入 ")], -1))]),
      _: 1
    }), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[3] || (_cache[3] = $event => $data.showUrlDialog = false)
    }, {
      default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("确定")])),
      _: 1
    })])]),
    _: 1
  }, 8, ["modelValue", "width"]), _createVNode(_component_el_dialog, {
    title: "上传设置",
    modelValue: $data.showCompressDialog,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.showCompressDialog = $event),
    width: $options.dialogWidth,
    "show-close": false
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      "label-width": "25%"
    }, {
      default: _withCtx(() => [_cache[31] || (_cache[31] = _createElementVNode("p", {
        style: {
          "font-size": "medium",
          "font-weight": "bold"
        }
      }, "上传渠道", -1)), _createVNode(_component_el_form_item, {
        label: "上传渠道"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.uploadChannel,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.uploadChannel = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: "telegram"
          }, {
            default: _withCtx(() => _cache[25] || (_cache[25] = [_createTextVNode("Telegram")])),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: "cfr2"
          }, {
            default: _withCtx(() => _cache[26] || (_cache[26] = [_createTextVNode("Cloudflare R2")])),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "失败自动切换"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.autoRetry,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.autoRetry = $event),
          "active-text": "开启",
          "inactive-text": "关闭",
          "active-color": "#13ce66",
          "inactive-color": "#ff4949"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _cache[32] || (_cache[32] = _createElementVNode("p", {
        style: {
          "font-size": "medium",
          "font-weight": "bold"
        }
      }, "文件命名方式", -1)), _createVNode(_component_el_form_item, {
        label: "命名方式"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.uploadNameType,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.uploadNameType = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: "default"
          }, {
            default: _withCtx(() => _cache[27] || (_cache[27] = [_createTextVNode("默认")])),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: "index"
          }, {
            default: _withCtx(() => _cache[28] || (_cache[28] = [_createTextVNode("仅前缀")])),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: "origin"
          }, {
            default: _withCtx(() => _cache[29] || (_cache[29] = [_createTextVNode("仅原名")])),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _cache[33] || (_cache[33] = _createElementVNode("p", {
        style: {
          "font-size": "medium",
          "font-weight": "bold"
        }
      }, "客户端压缩", -1)), _createVNode(_component_el_form_item, {
        label: "开启压缩"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.customerCompress,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.customerCompress = $event),
          "active-text": "开启",
          "inactive-text": "关闭",
          "active-color": "#13ce66",
          "inactive-color": "#ff4949"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), $data.customerCompress ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 0,
        label: "压缩阈值"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_slider, {
          modelValue: $data.compressBar,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.compressBar = $event),
          min: 1,
          max: 20,
          "show-input": ""
        }, null, 8, ["modelValue"])]),
        _: 1
      })) : _createCommentVNode("", true), $data.customerCompress ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 1,
        label: "压缩后大小"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_slider, {
          modelValue: $data.compressQuality,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.compressQuality = $event),
          min: 1,
          max: $data.compressBar,
          "show-input": ""
        }, null, 8, ["modelValue", "max"])]),
        _: 1
      })) : _createCommentVNode("", true), $data.uploadChannel === 'telegram' ? (_openBlock(), _createElementBlock("p", _hoisted_9, "服务端压缩")) : _createCommentVNode("", true), $data.uploadChannel === 'telegram' ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 3,
        label: "开启压缩"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.serverCompress,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.serverCompress = $event),
          "active-text": "开启",
          "inactive-text": "关闭",
          "active-color": "#13ce66",
          "inactive-color": "#ff4949"
        }, null, 8, ["modelValue"])]),
        _: 1
      })) : _createCommentVNode("", true), _cache[34] || (_cache[34] = _createElementVNode("p", {
        style: {
          "text-align": "left",
          "font-size": "small"
        }
      }, [_createElementVNode("br"), _createTextVNode("*Tips: "), _createElementVNode("br"), _createTextVNode("1.Telegram渠道和CloudFlare R2渠道配置方式不同，请根据文档分别配置后使用 "), _createElementVNode("br"), _createTextVNode("2.压缩设置仅针对图片文件，单位为MB "), _createElementVNode("br"), _createTextVNode("3.客户端压缩指上传前压缩，服务端压缩仅作用于Telegram渠道 "), _createElementVNode("br"), _createTextVNode("4.若图片大小>10MB，或压缩后图片大小>10MB，服务端压缩将自动失效 "), _createElementVNode("br"), _createTextVNode("5.若图片大小>20MB，将自动进行客户端压缩 "), _createElementVNode("br"), _createTextVNode("6.若想要存储的图片和原图完全一致，可以将两个压缩设置均设置为关闭 "), _createElementVNode("br"), _createTextVNode("7.若上传分辨率过大、透明背景等图片，建议关闭服务端压缩，否则可能出现未知问题 ")], -1)), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[12] || (_cache[12] = $event => $data.showCompressDialog = false)
      }, {
        default: _withCtx(() => _cache[30] || (_cache[30] = [_createTextVNode("确定")])),
        _: 1
      })])]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue", "width"])]), _createVNode(_component_Footer, {
    class: "footer"
  })]);
}